import {Box, Grid, Theme, Typography} from '@mui/material';
import React, {FC, memo} from 'react';
import {useSelector} from 'react-redux';
import {localized, localizedDynamic, localizedInterpolation} from '../../../../../i18n/i18n';
import {AppState} from '../../../../../state/store';
import {disabledButtonColor} from '../../../../../styles/color-constants';
import {
  getUnitLenghtByCulture,
  getUnitLengthNameByCulture,
  getValueLengthWithUnitByCulture,
} from '../../../../../utilities/helpers/culture-settings-helper';
import {onlyNumbersWithCommaDotSpaceFraction} from '../../../../../utilities/helpers/form-helper';
import {getConfigurationParamByNameAndCulture} from '../../../../../utilities/helpers/product-helper';
import {requiredValidatorDynamicMsg} from '../../../../../utilities/platform-helpers/validator-helper';
import {TextInput} from '../../../default-components/form/text-input';
import {TextInputLabel} from '../../form/text-input-label';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formTextInputBox: {
      width: '250px',
      display: 'flex',
      justifyContent: 'center',
      [`& fieldset`]: {
        border: '1px solid',
        borderColor: disabledButtonColor,
        borderRadius: 0,
      },
    },
    unitText: {
      fontWeight: 'bold',
      alignSelf: 'center',
      marginLeft: 10,
    },
  }),
);

export interface PropsFromParent {
  formName: string;
  minValue: string;
  maxValue: string;
  textInputLabel: string;
  tooltipLabel: string;
  hintLabel?: string;
  formOnChange?: (event: any) => void;
  defaultValue?: string;
}

export const ValueRangeInput: FC<PropsFromParent> = memo((props) => {
  const classes = useStyles();
  const {unitsId} = useSelector((store: AppState) => store.urlSettingsReducer.cultureUrlParameters);
  const selectedProduct = useSelector((store: AppState) => store.projectReducer.selectedProduct);

  return (
    <>
      <Grid item xs={7}>
        <TextInputLabel
          name={props.formName}
          label={props.textInputLabel}
          hintLabel={
            props.hintLabel ??
            '(' +
              localizedInterpolation('BetweenXandY', {
                value1: getValueLengthWithUnitByCulture(unitsId, props.minValue),
                value2: getValueLengthWithUnitByCulture(unitsId, props.maxValue),
              }) +
              ')'
          }
          tooltipLabel={props.tooltipLabel}
        />
      </Grid>
      <Grid item xs={5}>
        <Box className={classes.formTextInputBox}>
          {
            <TextInput
              name={props.formName}
              defaultValue={
                props.defaultValue ?? getConfigurationParamByNameAndCulture(selectedProduct, props.formName, unitsId)
              }
              validators={{
                ...requiredValidatorDynamicMsg(localized('FieldIsRequired')),
                min: {
                  value: getUnitLenghtByCulture(unitsId, props.minValue),
                  message:
                    localizedDynamic('ValueMustBeOver') +
                    ' ' +
                    getValueLengthWithUnitByCulture(unitsId, props.minValue),
                },
                max: {
                  value: getUnitLenghtByCulture(unitsId, props.maxValue),
                  message:
                    localizedDynamic('ValueMustBeUnder') +
                    ' ' +
                    getValueLengthWithUnitByCulture(unitsId, props.maxValue),
                },
                pattern: {
                  value: onlyNumbersWithCommaDotSpaceFraction,
                  message: localized('PleaseEnterANumber'),
                },
                onChange: props.formOnChange,
              }}
            />
          }

          <Typography className={classes.unitText}>{getUnitLengthNameByCulture(unitsId)}</Typography>
        </Box>
      </Grid>
    </>
  );
});
